/**
 * G-94 — does this item's stock move by FIFO batch?
 *
 * One question, three consequences, and until now it was written out by hand at
 * each of them:
 *
 *  - its quantity cannot be hand-set (`AdjustInventoryStockModal` is refused),
 *  - it is received through `receive-flower-batch`, with a supplier and
 *    separate invoiced/usable quantities, not `receive-single-use`,
 *  - and the kiosk refuses to count or receive it at all (G-86).
 *
 * The server states it once — `receiveSingleUse` throws for a perishable item
 * and for anything in `ITEM_CATEGORY_CODES_EXCLUDED_FROM_INVENTORY_UNIT_PRICE`,
 * which is `["FLOWER"]` (`src/common/constants/domain-enums.ts:300`). This is
 * the frontend's single copy of that same sentence. Two places had it inline
 * before (`InventoryPanel`'s Adjust button and G-94's item card); a third was
 * about to be written for the merged receive door, which is how two rules
 * claiming the same thing start to drift — the failure G-30 had to delete a
 * duplicated VAT calculation for.
 *
 * The server remains the authority. This decides which form to show, never
 * whether the write is allowed.
 */
export function movesByBatch(item: {
  isPerishable: boolean;
  category: { code: string };
}): boolean {
  return item.isPerishable || item.category.code === "FLOWER";
}
